import React from 'react';
import { Facebook } from 'react-feather';
import styled from 'styled-components';
import IconContainer from './IconContainer';
const IconContainerExtended = styled(IconContainer) `
    background: #3b5998;
`;
const IxuFacebook = (props) => (React.createElement(IconContainerExtended, { ...props },
    React.createElement(Facebook, { color: "white" })));
export default IxuFacebook;
//# sourceMappingURL=IxuFacebook.js.map